module.exports = __webpack_public_path__ + "static/img/280-40.569265f1.jpg";